// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #ffffff !important;
  border-radius: 6px;
  padding: 0;
  width: 500px;
  max-width: 90vw;
  max-height: 90vh;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  color: #333333 !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa !important;
  position: sticky;
  top: 0;
  z-index: 10;
  color: #333333 !important;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
}

.modal-close-button {
  background: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid #dee2e6 !important;
  font-size: 24px;
  cursor: pointer;
  color: #212529 !important;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-weight: bold !important;
}

.modal-close-button:hover:not(:disabled) {
  background: #ffffff !important;
  border-color: #adb5bd !important;
  color: #000000 !important;
  border-radius: 6px !important;
}

.modal-close-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.modal-form {
  padding: 24px;
  background: #ffffff !important;
  color: #333333 !important;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333333 !important;
  font-size: 0.9rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
  font-family: inherit;
  background: #ffffff !important;
  color: #333333 !important;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-group input:disabled,
.form-group textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
}

.cancel-button,
.submit-button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-button {
  background: #6c757d !important;
  color: white !important;
}

.cancel-button:hover:not(:disabled) {
  background: #5a6268 !important;
  transform: translateY(-1px);
}

.submit-button {
  background: #007bff !important;
  color: white !important;
}

.submit-button:hover:not(:disabled) {
  background: #0056b3 !important;
}

.cancel-button:disabled,
.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Responsive */
@media (max-width: 576px) {
  .modal-content {
    width: 95vw;
    margin: 20px;
  }
  
  .modal-header {
    padding: 16px 20px;
  }
  
  .modal-form {
    padding: 20px;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .cancel-button,
  .submit-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/CreateMasterProjectModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #ffffff !important;\n  border-radius: 6px;\n  padding: 0;\n  width: 500px;\n  max-width: 90vw;\n  max-height: 90vh;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  color: #333333 !important;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa !important;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  color: #333333 !important;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.modal-close-button {\n  background: rgba(255, 255, 255, 0.8) !important;\n  border: 1px solid #dee2e6 !important;\n  font-size: 24px;\n  cursor: pointer;\n  color: #212529 !important;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  font-weight: bold !important;\n}\n\n.modal-close-button:hover:not(:disabled) {\n  background: #ffffff !important;\n  border-color: #adb5bd !important;\n  color: #000000 !important;\n  border-radius: 6px !important;\n}\n\n.modal-close-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.modal-form {\n  padding: 24px;\n  background: #ffffff !important;\n  color: #333333 !important;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #333333 !important;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease;\n  font-family: inherit;\n  background: #ffffff !important;\n  color: #333333 !important;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-group input:disabled,\n.form-group textarea:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 24px;\n}\n\n.cancel-button,\n.submit-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 100px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancel-button {\n  background: #6c757d !important;\n  color: white !important;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: #5a6268 !important;\n  transform: translateY(-1px);\n}\n\n.submit-button {\n  background: #007bff !important;\n  color: white !important;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: #0056b3 !important;\n}\n\n.cancel-button:disabled,\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive */\n@media (max-width: 576px) {\n  .modal-content {\n    width: 95vw;\n    margin: 20px;\n  }\n  \n  .modal-header {\n    padding: 16px 20px;\n  }\n  \n  .modal-form {\n    padding: 20px;\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n  }\n  \n  .cancel-button,\n  .submit-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
